// いいねボタンの出入り＋小ハート演出（/report/ SECTION 03）
//
// スライドの切り替わりに同期して、ボタン本体が
//   少し縮んで消える → 移動中は非表示 → 軽く大きくなりながら現れる → 同時に小ハートがヒラヒラ
// を繰り返す（クライアント絵コンテ5コマ）。
//
// ここが持つのは「状態」と「ハートを何個どんな数字で生やすか」だけ。
//   ・いつ動くか … Slider.js が投げる slider:phase（leave / hide / show / stay）に従う。
//     Splide のインスタンスには触らないので、スライダー側の実装が変わっても壊れない
//   ・どう動くか … CSS（_like.scss の状態クラス、global/_keyframes.scss）。
//     JS はクラスの付け外しだけで、毎フレームは走らない
// 疑似要素は ::before / ::after を波紋で使い切っているので、ハートは実DOMを生成する。

const SELECTOR    = '.js-likeBtn';
const PHASE_EVENT = 'slider:phase';

// 初期表示。節（.p-reportSlider）は observer.js が is-visible を付けて 0.6s でフェードインする。
// ボタンはそれが終わってから登場させる（ユーザー指示「スライダーが出てからハートが出る」）。
// 節のフェードイン時間 + ひと呼吸
const INTRO_VISIBLE_CLASS = 'is-visible';
const INTRO_DELAY = 800;

// ====== 調整ノブ（小ハート） ======
// 絵コンテ⑤「一瞬のアクション。長くて1秒程度」を叩き台にし、「ちょっと早い」の指摘で
// 寿命と横揺れをゆったり側へ寄せた（旧 600〜900 / 200〜320）。上昇距離は据え置きなので速度だけ落ちる。
// 画面に出ている時間 ≒ (個数-1) × ずらし + 寿命。現在値: 5×55 + 1250 ≒ 1.5秒。
// 次のスライドまで4秒あるので、前の波は必ず消えている
const TUNE = {
  MAX_LIVE:      12,                    // 同時に生きているハートの上限（安全弁）
  WAVE_MIN:       4, WAVE_MAX:       6, // 1波の個数
  STEP_MIN:      40, STEP_MAX:      70, // 波の中のずらし(ms)。同時ではなく吹き上がりに見せる
  DUR_MIN:      900, DUR_MAX:     1250, // 寿命(ms)
  RISE_MIN:      60, RISE_MAX:      95, // 上昇距離(px)。寿命と一緒に動かさないと速さが変わる
  SIZE_MIN:      12, SIZE_MAX:      20, // 大きさ(px)。ボタン本体56pxとの比で見る
  OFFSET_MIN:   -18, OFFSET_MAX:    18, // 発射位置の左右ばらつき(px)
  SWAY_MIN:       6, SWAY_MAX:      12, // 横揺れの片道(px)。実際の横移動は2倍
  SWAY_DUR_MIN: 320, SWAY_DUR_MAX: 480, // 横揺れの片道時間(ms)。寿命÷これ が「何回揺れるか」
  CLICK_COUNT:    6, CLICK_STEP:    50, // 押した時のバースト
};

// Figma のボタン色 #e52b00 から朱〜橙に散らす
const HUES = ['#e52b00', '#ff4e1a', '#ff7a45', '#ffa06b'];

// ハートの形は symbols.ejs の <symbol id="heart">（Figma 書き出しそのまま）を使い回す。
// ボタンの静止ハートと浮上ハートで同じ1枚を参照するので、形の二重管理が起きない
const MARK = '<svg><use xlink:href="#heart"></use></svg>';

const rand = (min, max) => min + Math.random() * (max - min);
const rint = (min, max) => Math.round(rand(min, max));
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

const spawn = (layer) => {
  if (layer.childElementCount >= TUNE.MAX_LIVE) return;

  // 横揺れの片道時間。位相の抽選幅はこの2倍（= alternate の1周期）にする。
  // 埋めきらないと、全部のハートが同じ向きに揃って生まれる
  const swayDur = rint(TUNE.SWAY_DUR_MIN, TUNE.SWAY_DUR_MAX);

  const heart = document.createElement('span');
  heart.className = 'c-likeBtn__heart';
  // ばらつきは全部 CSS変数で渡す。動きの定義は SCSS 側に置いたまま
  heart.style.setProperty('--rise',       `${rint(TUNE.RISE_MIN, TUNE.RISE_MAX)}px`);
  heart.style.setProperty('--dur',        `${rint(TUNE.DUR_MIN, TUNE.DUR_MAX)}ms`);
  heart.style.setProperty('--size',       `${rint(TUNE.SIZE_MIN, TUNE.SIZE_MAX)}px`);
  heart.style.setProperty('--offset',     `${rint(TUNE.OFFSET_MIN, TUNE.OFFSET_MAX)}px`);
  heart.style.setProperty('--sway',       `${rint(TUNE.SWAY_MIN, TUNE.SWAY_MAX)}px`);
  heart.style.setProperty('--sway-dur',   `${swayDur}ms`);
  heart.style.setProperty('--sway-phase', `-${rint(0, swayDur * 2)}ms`);
  heart.style.setProperty('--clr',        pick(HUES));

  const sway = document.createElement('span');
  sway.className = 'c-likeBtn__sway';
  sway.innerHTML = MARK;
  heart.appendChild(sway);

  // 寿命が尽きたら必ず捨てる。これが無いと DOM が増え続ける。
  // animationName では判定しないこと。cssnano が @keyframes 名を a / b / c に潰すので、
  // 本番ビルドだけ一致しなくなる（実際 assets/css/style.css は潰れている）。
  // 上昇・拡縮・明滅の3本は --dur を共有していて同時に終わり、
  // 内側の横揺れ・傾きは infinite なので animationend を投げない。
  // よって「この要素自身のアニメが1本でも終わった＝寿命が尽きた」で判定できる
  heart.addEventListener('animationend', (e) => {
    if (e.target === heart) heart.remove();
  });

  layer.appendChild(heart);
};

const setup = (root) => {
  const layer = root.querySelector('.js-likeBtnLayer');
  if (!layer) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let inView = false;

  const burst = (count, step) => {
    for (let i = 0; i < count; i += 1) {
      setTimeout(() => spawn(layer), i * step);
    }
  };

  // 画面外・裏タブ・OSの動き低減設定ではハートを出さない。
  // ボタンの出入り（クラスの付け外し）は止めない。4秒に2回で無視できる軽さだし、
  // 止めると復帰したとき .is-hidden のまま取り残される
  const canPlay = () => inView && !reduce.matches && !document.hidden;

  const io = new IntersectionObserver((entries) => {
    inView = entries[0].isIntersecting;
  }, { rootMargin: '0px 0px -10% 0px' });
  io.observe(root);

  // ====== ボタン本体の状態機械 ======
  // shown → leaving → hidden → shown の一方向。
  // 「現れる」は状態ではない。.is-hidden を外すと CSS の transition が 1 へ戻す（_like.scss）。
  // フェードイン中を別状態にすると「終わった」を知るのに transitionend かタイマーが要るので持たない。
  // 初期状態は hidden（マークアップの is-hidden と揃える）。節が現れるまで登場させない
  let state = 'hidden';  // 'shown' | 'leaving' | 'hidden'

  const toLeaving = () => {
    if (state !== 'shown') return;
    root.classList.add('is-leaving');
    state = 'leaving';
  };

  const toHidden = () => {
    if (state === 'hidden') return;
    root.classList.remove('is-leaving');
    root.classList.add('is-hidden');
    state = 'hidden';
  };

  // withHearts: 小ハートを出すか。非表示からの再登場なら出す。
  // 消えかけたが切り替わらなかった（stay）ときは、静かに戻すだけで出さない
  const toShown = (withHearts) => {
    root.classList.remove('is-leaving', 'is-hidden');
    // ボタンの再表示とハートは1つの出来事。同じカードに戻っただけでも出す
    if (withHearts && canPlay()) burst(rint(TUNE.WAVE_MIN, TUNE.WAVE_MAX), rint(TUNE.STEP_MIN, TUNE.STEP_MAX));
    state = 'shown';
  };

  // ====== 初期表示 ======
  // 節が見えるまでは Splide からの合図を「記録するだけ」にして、ボタンは非表示のまま。
  // スクロールが遅くてスライダーが何周か回った後に節が現れても、必ず「節が出てから登場」になる
  let introduced = false;
  let lastPhase  = '';

  const intro = () => {
    if (introduced) return;
    introduced = true;
    // ちょうどカードが動いている最中（直前の合図が hide）なら、この後に来る show に登場を任せる。
    // ここで出すと 1秒のうちに2回ポップする
    if (lastPhase !== 'hide') toShown(true);
  };

  const scope = root.parentElement || document;
  const scheduleIntro = () => setTimeout(intro, INTRO_DELAY);

  if (scope.classList && scope.classList.contains(INTRO_VISIBLE_CLASS)) {
    scheduleIntro();
  } else if (scope.classList) {
    // is-visible が付く瞬間だけ拾う。付いたら監視は用済み
    const mo = new MutationObserver(() => {
      if (!scope.classList.contains(INTRO_VISIBLE_CLASS)) return;
      mo.disconnect();
      scheduleIntro();
    });
    mo.observe(scope, { attributes: true, attributeFilter: ['class'] });
  } else {
    scheduleIntro();
  }

  // 合図はスライダーの root から上がってくるので、ボタンと同じ節（.p-reportSlider）で受ける。
  // 互いの初期化順に依存しない
  scope.addEventListener(PHASE_EVENT, (e) => {
    const phase = e.detail && e.detail.phase;
    lastPhase = phase;
    if (!introduced) return;  // 節が現れる前は覚えるだけ（hidden を維持）
    switch (phase) {
      case 'leave': toLeaving();     break;
      case 'hide':  toHidden();      break;
      case 'show':  toShown(true);   break;
      case 'stay':  if (state === 'leaving') toShown(false); break;
      default: break;
    }
  });

  // 押した瞬間だけ密度を上げる。「自分の1票が乗った」感を出す
  root.addEventListener('click', () => {
    if (reduce.matches) return;
    burst(TUNE.CLICK_COUNT, TUNE.CLICK_STEP);
  });
};

const likeReaction = {
  init() {
    document.querySelectorAll(SELECTOR).forEach(setup);
  }
};

export default likeReaction;
